import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Carriers_ds_carrierservices_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { carrierId: number, fullTextSearch?: string }): 
  Promise<{ result: { CarrierId?: number, ServiceTypeId?: number, Name?: string, Service_Type?: string, ServiceClass?: string, ServiceGroup?: string, ServiceMode?: string, Carrier?: { Name?: string, ScacCode?: string, ShortName?: string }, ServiceType?: { Name?: string, ShortName?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.carrierId)) {
      missingRequiredInParams.push('\'carrierId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Carriers/datasources/ds_carrierservices_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { carrierId: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { CarrierId?: number, ServiceTypeId?: number, Name?: string, Service_Type?: string, ServiceClass?: string, ServiceGroup?: string, ServiceMode?: string, Carrier?: { Name?: string, ScacCode?: string, ShortName?: string }, ServiceType?: { Name?: string, ShortName?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.carrierId)) {
      missingRequiredInParams.push('\'carrierId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Carriers/datasources/ds_carrierservices_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { carrierId: number, fullTextSearch?: string, $keys: { CarrierId?: number, ServiceTypeId?: number }[] }): 
  Promise<{ result: { CarrierId?: number, ServiceTypeId?: number, Name?: string, Service_Type?: string, ServiceClass?: string, ServiceGroup?: string, ServiceMode?: string, Carrier?: { Name?: string, ScacCode?: string, ShortName?: string }, ServiceType?: { Name?: string, ShortName?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.carrierId)) {
      missingRequiredInParams.push('\'carrierId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Carriers/datasources/ds_carrierservices_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      carrierId: number, fullTextSearch?: string    }) {
        if(isNil(inParams.carrierId)) {
          return true; 
        }
      return false;
    }
}
